import React from "react";

const Tick = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.70605 12.5L10.3731 17L19.7061 8" stroke="#5D5F62" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    )
}

export default Tick;